import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  display: ${({ show }) => {
    return show ? 'flex' : 'none';
  }};
  overflow: hidden;
  min-height: 100vh;
  width: ${(props) => {
    return props.width ? `${props.width}px` : '600px';
  }};
  background-color: ${color.grey3};
  position: fixed;
  right: 0;
  top: 0;
  z-index: 50;
  flex-direction: column;
  justify-content: space-between;
  .component_note_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${color.white};
    padding: 24px;
    .anticon {
      font-size: 16px;
      color: ${color.black2};
      cursor: pointer;
    }
  }

  .component_note_content {
    padding: 24px;
    overflow-y: ${(props) => {
      if (props.noScroll) {
        return 'visible';
      }
      return 'scroll';
    }};
    /* max-height: 840px; */
    flex-grow: 2;
    background-color: ${color.white};
  }

  .component_note_input {
    width: 100%;
    /* position: absolute; */
    /* bottom: 0; */
    padding: 24px;
    background-color: ${color.white};
    display: flex;
    align-items: flex-end;
    column-gap: 12px;
    textarea {
      border: 1px solid ${color.grey1} !important;
      border-radius: 12px;
      min-height: 44px !important;
      line-height: 30px;
    }
  }
`;

export default Wrapper;

export const MessageWrapper = styled.div`
  background-color: ${color.white};
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  .component_message_header {
    position: relative;
    display: flex;
    align-items: center;
    column-gap: 8px;
    margin-bottom: 16px;

    .anticon {
      position: absolute;
      right: 0;
      color: ${color.black2};
      cursor: pointer;
    }
  }
`;
